import { Component, computed, signal } from '@angular/core';
import { CreateTabComponent } from '../../../../../shared/ui/create-tab-component/create-tab-component';
import { CreateBundleIncludedComponent } from './create-bundle-included-component/create-bundle-included-component';
import { CreateBundleInfoComponent } from './create-bundle-info-component/create-bundle-info-component';
import { TabStep } from '../../../../../shared/ui/create-tab-component/tabs.model';

@Component({
  selector: 'app-create-bundle-component',
  imports: [CreateTabComponent, CreateBundleIncludedComponent, CreateBundleInfoComponent],
  templateUrl: './create-bundle-component.html',
  styleUrl: './create-bundle-component.scss',
})
export class CreateBundleComponent {
  bundleSteps: TabStep[] = [
    { id: 1, labelen: 'Bundle Information', labelar: 'معلومات الباقة' },
    { id: 2, labelen: 'Included Products', labelar: 'الأصناف المشمولة بالباقة' },
  ];

  activeStep = signal(1);

  completedSteps = signal<number[]>([]);

  createdBundleId = signal<number | null>(null);
  disabledSteps = computed(() => (this.createdBundleId() ? [] : [2]));

  onBundleCreated(newId: number) {
    this.createdBundleId.set(newId);
    this.completedSteps.update((steps) => [...steps, 1]);
    this.activeStep.set(2);
  }

  handleStepChange(stepId: number) {
    this.activeStep.set(stepId);
  }
}
